import { ContainerStyles } from 'src/interfaces/styles'

// TODO
export const grid = (styles: ContainerStyles) => `
  ${styles.grid ? `
    display: grid;
    grid-template-columns: ${Array(styles.grid).fill("1fr").join(" ")};
  ` : ''}
`
